import { css } from '@emotion/css';
import { id } from 'Shared/forms/Inputs'
import { labelStyle } from 'Shared/forms/Wrap'
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import { Sides } from 'Shared/backend/styles/Sides';
import { splitLocation,subdoc } from 'Common/ViewUtils';
import { createMemo } from 'solid-js';
import { Amount } from 'Shared/forms/Amount';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';



export function Padding()
{
	return (
		<StyleFieldsRow>
			<PaddingFields />
		</StyleFieldsRow>
	);
}


/* The padding on its own, for a caller that names the location itself - see ruleProperties(). */
export function PaddingFields()
{
	const gridStyle = css({
		width: 0,
		display: 'grid',
		gridTemplateColumns: 'auto auto auto auto',
		columnGap: '1em',
		rowGap: '0.5em',

		'& > :nth-child(3)': {
			marginLeft: '3em'
		},
		'& > :nth-child(7)': {
			marginLeft: '3em'
		}
	});

	const sw = useStore();
	const defaults = () => undefined;

	return (
		<Sides
			label=''
			property='padding'
			settings={PaddingSettings}
			defaults={defaults}
			sides={(subdoc(sw.store, sw.location ?? []) as any)?.padding?.sides}
			style={gridStyle}
		/>
	);
}

function PaddingSettings(P:{label:string,name:string})
{
	const sw = useStore();

	const loc = createMemo(() => {
		const fullLocation = [...sw.location,'padding',P.name];
		const [location,field] = splitLocation(fullLocation);
		return {location:location,field:field};
	});

	return (
		<StoreProvider {...sw} location={loc().location}>
			<label class={labelStyle()} for={id(loc().field)}>{P.label}</label>

			<Amount field={loc().field} options={{em:'em',px:'px',percent:'%'}} />
		</StoreProvider>
	);
}

